import { Injectable } from '@angular/core';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  getRelativeDate(date: Date | string): string {
    if (!date) return "";
    if (typeof date === 'string') date = new Date(date);

    const formatter = new Intl.RelativeTimeFormat('es-ES', {
      numeric: 'auto',
    })

    const diff = date.getTime() - new Date().getTime();
    const seconds = diff / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const months = days / 30;
    const years = days / 365;

    if (years <= -1) return formatter.format(Math.round(years), 'years');
    if (months <= -1) return formatter.format(Math.round(months), 'months');
    if (days <= -1) return formatter.format(Math.round(days), 'days');
    if (hours <= -1) return formatter.format(Math.round(hours), 'hours');
    if (minutes <= -1) return formatter.format(Math.round(minutes), 'minutes');
    return formatter.format(Math.round(seconds), 'seconds');
  }

  getRelativeDateTimer(targetDate: Date): string {
    const diff = targetDate.getTime() - new Date().getTime();
    const hours = this.formatTimeNumber(diff / (60 * 60 * 1000));
    const minutes = this.formatTimeNumber(diff % (60 * 60 * 1000) / (60 * 1000));
    const seconds = this.formatTimeNumber(diff % (60 * 1000) / 1000);
    return `${hours}:${minutes}:${seconds}`
  }

  formatTimeNumber(value: number): string {
    return Math.floor(value).toLocaleString('es-ES', {
      minimumIntegerDigits: 2,
      useGrouping: false
    });
  }

  addBusinessDays(startDate: Date, businessDaysToAdd: number): Date {
    const resultDate = new Date(startDate);

    while (businessDaysToAdd > 0) {
      resultDate.setDate(resultDate.getDate() + 1);

      // Check if the current day is a weekend (Saturday or Sunday)
      if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
        businessDaysToAdd--;
      }
    }

    return resultDate;
  }

  getMaxDate(date: Date) {
    const lessonInitDateTimestamp = new Date(date)?.getTime() || Number.NEGATIVE_INFINITY;
    const twoBusinessDaysFromNowTimestamp = this.addBusinessDays(new Date(), 2).getTime();

    return this.formatDate(
      new Date(Math.max(lessonInitDateTimestamp, twoBusinessDaysFromNowTimestamp))
    );
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString("fr-CA", {year:"numeric", month: "2-digit", day:"2-digit"});
  }

  formatDateTime(date: Date): string {
    return format(new Date(date +'Z'), "dd/MM/yy HH:mm").toLocaleString()
  }

  formatMinutesToHHMM(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);

    // Formatea los minutos para que tengan dos dígitos
    const formattedMins = mins < 10 ? `0${mins}` : `${mins}`;

    // console.log(`${hours}:${formattedMins}`);

    return `${hours}:${formattedMins}`;
  }

  // Function to get start and end of the current week (Monday to Sunday)
  getWeekRange() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const dayOfMonth = now.getDate();

    const monday = new Date(now);
    monday.setDate(dayOfMonth - ((dayOfWeek + 6) % 7));

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return { start: monday.getTime(), end: sunday.getTime() };
  }

  // Function to get start and end of the current month
  getMonthRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0).getTime();

    return { start, end };
  }

  // Function to get start and end of the current year
  getYearRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1).getTime();
    const end = new Date(now.getFullYear(), 11, 31).getTime();

    return { start, end };
  }

  lastNDaysRange(n: number) {
    const now = new Date();
    const lastNDays = new Date(now);
    lastNDays.setDate(now.getDate() - n);

    return { start: lastNDays.getTime(), end: now.getTime() };
  }

  // Function to get start and end of the current month
  /*last30DaysRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0).getTime();

    return { start, end };
  }

  // Function to get start and end of the current year
  last365DaysRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1).getTime();
    const end = new Date(now.getFullYear(), 11, 31).getTime();

    return { start, end };
  }*/
}
